import { render, staticRenderFns } from "./NetdocSite.vue?vue&type=template&id=ef0c12aa&scoped=true"
import script from "./NetdocSite.vue?vue&type=script&lang=js"
export * from "./NetdocSite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0c12aa",
  null
  
)

export default component.exports